"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberFormatterCustomCheckbox = void 0;
const React = require("react");
const react_1 = require("react");
class NumberFormatterCustomCheckbox extends react_1.Component {
    constructor(props) {
        super(props);
        // method working as a callable to update the value in the parent component
        this.invokeParentMethod = () => {
            this.props.context.componentParent.checkboxMethodFromParent(this.props.value);
        };
        this.invokeParentMethod = this.invokeParentMethod.bind(this);
    }
    render() {
        if (this.props.value ||
            this.props.value === 0 ||
            this.props.value === false ||
            this.props.value === "") {
            // shows the isDistributor checkboxes along with inv names
            if (!this.props.node.group) {
                const { name } = this.props.node.data;
                const { value } = this.props;
                const checked = !!value;
                return (React.createElement("span", null,
                    React.createElement("input", { type: "checkbox", value: this.props.value, onChange: this.invokeParentMethod, checked: checked }),
                    name));
            }
            // shows the group row
            return (React.createElement("span", null,
                React.createElement("strong", null, this.props.value === "" ? "(NOT SET)" : this.props.value)));
        }
        return React.createElement("span", null);
    }
}
exports.NumberFormatterCustomCheckbox = NumberFormatterCustomCheckbox;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/claim-analytics/number-formatter-custom-checkbox.tsx
// module id = 3560
// module chunks = 0